import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlResolverService } from "./helpers/url-resolver.service";
import { StateProvince } from "../models/lookup/state-province";
import { lastValueFrom, Observable, shareReplay } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LookupService {
    private _states$?: Observable<StateProvince[]>;

    constructor(
        private readonly _http: HttpClient,
        private readonly _urlResolver: UrlResolverService
    ) {

    }

    public getAllStates(): Promise<StateProvince[]> {
        if (!this._states$) {
            const url = this._urlResolver.resolveUrl('api/lookup/states');
            this._states$ = this._http.get<StateProvince[]>(url).pipe(shareReplay(1))
        }

        return lastValueFrom(this._states$);
    }
}